import {Component, OnInit, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ConfirmFileModalComponent} from "./modal/confirm-file-modal-component";
import {UploadAwardsService} from "../../core/upload-awards/upload-awards.service";
import {MessageService} from "primeng/components/common/messageservice";
import {HttpParams} from "@angular/common/http";

declare var $;
declare var ScrollMagic;

@Component({
  selector: 'app-upload-awards',
  templateUrl: './upload-awards.component.html',
  styleUrls: ['./upload-awards.component.scss']
})
export class UploadAwardsComponent implements OnInit, AfterViewInit {

  existsData = true;
  fileAwards ;
  isLoading = false;
  filezip = null;
  files = [];
  private scene: any;
  isEnter = false;
  page = 0;
  pageSize = 50;
  private pageNumber = 0;
  clicked = false
  constructor( private modalService: NgbModal,
               private uploadAwardsService: UploadAwardsService,
               public messageService: MessageService,) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    const controller = new ScrollMagic.Controller();
    this.scene = new ScrollMagic.Scene({triggerElement: '#loader', triggerHook: 'onEnter'})
      .addTo(controller)
      .on('enter', (e) => {
        setTimeout(() => {
          this.enter();
        });
      })
      .on('leave', (e) => {
        setTimeout(() => {
          console.log('leave');
        });
      });

  }

  enter() {
    console.log('enter method...');
    this.isEnter = true;
    if (this.existsData) {
      console.log('enter');
      const httpParams = this.getRequestOptions();
      this.debugRequest(httpParams);
      this.uploadAwardsService.getFilesUploaded(httpParams).subscribe((response) => {
        console.log(response);
        Array.prototype.push.apply(this.files, response);
        this.pageNumber = this.pageNumber + this.pageSize;
        if (response.length <= 50) {
          this.existsData = false;
        }
      });
      console.log('Dentor de get');
    } else {
      console.log("Ya no hay mas informacion");
    }
  }

  private debugRequest(options) {
    console.log('InfiniteScrollComponent#enter:pageNumber');
    console.log(this.pageNumber);
    console.log('InfiniteScrollComponent#enter:pageSize');
    console.log(this.pageSize);
    console.log('InfiniteScrollComponent#enter:options');
    console.log(options);
  }

  private getRequestOptions() {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('pageSize', this.pageSize.toString());
    httpParams = httpParams.set('offset', this.pageNumber.toString());
    return httpParams;
  }

  public selectFile(event) {
    this.clicked = true;
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      if(fileList[0].type == 'application/x-zip-compressed' ||
        fileList[0].type == 'application/x-zip' ||
        fileList[0].type == 'application/zip' ||
        fileList[0].type == 'application/octet-stream' ||
        fileList[0].type == 'zip' ){
        let file: File = fileList[0];
        this.fileAwards = fileList[0];
        this.confirmFile(file.name);
      }else {
        this.clicked = false;
        this.messageService.add({
          severity: 'warn',
          summary: '',
          detail: 'Por favor selecciona un archivo .zip'
        });
      }

    }
  }

  confirmFile(message) {
    const modalRef = this.modalService.open(ConfirmFileModalComponent, {backdrop: 'static'});
    modalRef.componentInstance.message = message;
    modalRef.result.then((result) => {
      if(result == 'confirm'){
        this.uploadFileServer();
      }else {
        this.clicked = false;
      }
    }, (reason) => {
      console.log(reason);
    });
  }

  uploadFileServer(){
    let file: File = this.fileAwards;
    let formData: FormData = new FormData()
    formData.append('file', file, file.name);
    //formData.append('fileType', 'zip');
    this.isLoading = true;
    this.uploadAwardsService.uploadFile(formData)
      .finally(() => this.isLoading = false)
      .subscribe(
      success => {
        console.log('success', success);
        this.filezip= "";
        this.files = [];
        this.existsData = true;
        this.pageNumber = 0;
        this.clicked = false;
        this.messageService.add({
          severity: 'success',
          summary: '',
          detail: 'Archivo cargado correctamente: '
        });
        this.enter();

      },
      error => {
        this.messageService.clear();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al subir el archivo'
        });
        this.clicked = false;
        console.log('error')
      }
    );
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/upload-awards/upload-awards.component.ts